import { baseTemplateQuestionConfigs } from '@omnea-app/packages/universal/formBuilder/baseSystemTemplateQuestionConfigs'

/* Note(Diego, SR-1223): These are the question IDs that are always locked for CREATE_AGREEMENT forms
 * https://linear.app/omnea/issue/SR-1223/surface-in-ui-which-fields-must-be-added-to-an-agreement-form */
export const systemAgreementQuestionIdsOverride = [
  baseTemplateQuestionConfigs.agreement.name,
  baseTemplateQuestionConfigs.product.name,
  baseTemplateQuestionConfigs.businessOwner.name,
  baseTemplateQuestionConfigs.contractPeriod.name,
  baseTemplateQuestionConfigs.agreementPricing.name,
]
export type SystemAgreementQuestionIdOverride = (typeof systemAgreementQuestionIdsOverride)[number]

/* Requiredness for a CSV import bulk update, distinct from the form-authoring lock above. Product is nullable on
 * an agreement term (AgreementInputTermSchema.product) — agreements can validly have none (e.g. migrated
 * engagements), so a CSV import bulk update must not force it, or a product-less agreement fails on a download→
 * re-upload it never changed. Removing a product is instead guarded in validateSupplierProductChanges
 * (a blank product cell can't wipe an existing one). The other locked questions are genuinely required
 * on a valid agreement, so they stay. (IC-633) */
export const csvImportBulkUpdateRequiredQuestionIds: SystemAgreementQuestionIdOverride[] =
  systemAgreementQuestionIdsOverride.filter((name) => name !== baseTemplateQuestionConfigs.product.name)

/* Note(Diego): Non omneans have more questions locked to prevent errors. I.e. renewal fields must all be present or all disabled AT THE SAME TIME
 * */
export const systemAgreementQuestionIds = [
  ...systemAgreementQuestionIdsOverride,
  baseTemplateQuestionConfigs.agreementRenewal.name,
  baseTemplateQuestionConfigs.renewalAssessmentNotice.name,
  baseTemplateQuestionConfigs.renewalAutoStartWorkflow.name,
  baseTemplateQuestionConfigs.renewalWorkflow.name,
] as const
